var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconSetCost(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.55 6.75016C12.3688 6.43592 12.1057 6.17686 11.7886 6.00071C11.4715 5.82456 11.1125 5.73795 10.75 5.75016H8.75C8.21957 5.75016 7.71086 5.96087 7.33579 6.33594C6.96071 6.71102 6.75 7.21972 6.75 7.75016C6.75 8.28059 6.96071 8.7893 7.33579 9.16437C7.71086 9.53944 8.21957 9.75016 8.75 9.75016H10.75C11.2804 9.75016 11.7891 9.96087 12.1642 10.3359C12.5393 10.711 12.75 11.2197 12.75 11.7502C12.75 12.2806 12.5393 12.7893 12.1642 13.1644C11.7891 13.5394 11.2804 13.7502 10.75 13.7502H8.75C8.38749 13.7624 8.02849 13.6758 7.71142 13.4996C7.39435 13.3235 7.13115 13.0644 6.95 12.7502M9.75 4.75V14.75M18.75 9.75C18.75 14.7206 14.7206 18.75 9.75 18.75C4.77944 18.75 0.75 14.7206 0.75 9.75C0.75 4.77944 4.77944 0.75 9.75 0.75C14.7206 0.75 18.75 4.77944 18.75 9.75Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSetCost);
export default __webpack_public_path__ + "static/media/icon_set_cost.739a71d240dfe9720081a682d7b22401.svg";
export { ForwardRef as ReactComponent };